import * as dotenv from 'dotenv';
dotenv.config();

const config = {
  nodeEnv: process.env.NODE_ENV,
  port: process.env.PORT || 4000,
  blocked: process.env?.REACT_APP_BLOCKED === 'true',
  armcareServerUrl: process.env.REACT_APP_ARMCARE_SERVER_URL ?? '',
  armcareNewServerUrl: process.env.REACT_APP_ARMCARE_NEW_SERVER_URL ?? '',
  armcareStripePK: process.env.REACT_APP_ARMCARE_STRIPE_PK ?? '',
  armcareUrl: process.env.REACT_APP_ARMCARE_URL ?? '',
};

export { config };
